module.exports = __webpack_public_path__ + "img/diamonds-1.31ba5cef.svg";